import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import { specials } from "@/mocks/specials";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuick from "@/pages/home/components/CategoryQuick";
import LatestSection from "@/pages/home/components/LatestSection";
import PopularRank from "@/pages/home/components/PopularRank";
import StarNewsStrip from "@/pages/home/components/StarNewsStrip";
import SpecialPicks from "@/pages/home/components/SpecialPicks";
import SiteIntro from "@/pages/home/components/SiteIntro";

const featuredIds = ["1", "2", "4", "8"];

export default function Home() {
  const featured = featuredIds
    .map((id) => movies.find((m) => m.id === id))
    .filter((m): m is (typeof movies)[number] => Boolean(m));

  const latest = [...movies].sort((a, b) => b.year - a.year).slice(0, 8);
  const popular = [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, 6);

  return (
    <div className="mx-auto w-full max-w-[1400px] px-4 py-8 md:px-6 md:py-10">
      <HeroCarousel movies={featured} />

      <section className="mt-10 md:mt-14">
        <SectionHeading
          eyebrow="Browse"
          title="按分类快速进入"
          desc="电影、电视剧、网络剧、短片，总有一类符合你的口味。"
        />
        <CategoryQuick />
      </section>

      <section className="mt-12 md:mt-16">
        <SectionHeading
          eyebrow="Latest"
          title="最新影视推荐"
          desc="刚刚上线或即将热播的激情题材作品，抢先了解剧情看点。"
          action={
            <Link
              to="/category"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-line" />
            </Link>
          }
        />
        <LatestSection movies={latest} />
      </section>

      <section className="mt-12 md:mt-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="Trending"
              title="热门影视榜单"
              desc="根据站内人气与讨论热度整理的精选作品。"
            />
            <PopularRank movies={popular} />
          </div>
          <div className="lg:col-span-1">
            <SectionHeading eyebrow="Stars" title="明星资讯" />
            <StarNewsStrip />
            <div className="mt-5 rounded-lg border border-background-200 bg-accent-50 p-5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-user-star-line" />
              </span>
              <h3 className="mt-3 text-base font-semibold text-foreground-950">追踪你喜欢的演员</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                明星资讯页汇集演员小传与代表作品，随时了解他们的最新动态与参演作品。
              </p>
              <Link
                to="/stars"
                className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600 cursor-pointer"
              >
                进入明星资讯
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-12 md:mt-16">
        <SectionHeading
          eyebrow="Collections"
          title="精选专题合集"
          desc="按主题打包推荐，一次看个够。"
          action={
            <Link
              to="/special"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
            >
              全部专题
              <i className="ri-arrow-right-line" />
            </Link>
          }
        />
        <SpecialPicks specials={specials.slice(0, 3)} />
      </section>

      <section className="mt-12 md:mt-16">
        <SiteIntro />
      </section>
    </div>
  );
}